import { Routes } from '@angular/router';
import { WRAPPER_ROUTES } from './core/pages/pages-wrapper/pages-wrapper.routes';

export const routes: Routes = [
  { path: '', children: WRAPPER_ROUTES },
  { path: ':lang', children: WRAPPER_ROUTES },
  { path: '**', redirectTo: '' },
];
